import { ICommand } from 'core-ts-types';
import { IRegistrationActivity } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { RequestActionServant } from '../../../views/registration_transactions/servants/request_action_servant';
class RegistrationErrorDetails {
  constructor(
    private registrationErrorDismissCommand: ICommand,
    private ngRequestActionServant: RequestActionServant
  ) {}

  dismissActivity(activity: IRegistrationActivity) {
    this.registrationErrorDismissCommand(_4.get(activity, 'id', 0));
  }
}

class RegistrationErrorDetailsComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      errors: '<'
    };
    this.controller = RegistrationErrorDetails;
    this.templateUrl =
      'capability-ng-scheduler/src/registration_errors/components/registration_error_details/registration_error_details.html';
  }
}
angular
  .module('capability-ng-scheduler')
  .component('registrationErrorDetails', new RegistrationErrorDetailsComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_errors/components/registration_error_details/registration_error_details.ts